import { withUiVersion } from 'hoc/withUiVersion';
import HeaderPrev from './Header';
import { Header as HeaderNext } from '../../v2/organisms/Header/Headerv2';

const Header = withUiVersion(HeaderPrev, HeaderNext);

export { Header };
